import { useEffect, useState } from "react";
import { getTextDirection } from "../utils/langUtil";

function useTextDirection(text: string) {
  const [textDirection, setTextDirection] = useState(getTextDirection(text));
  useEffect(() => setTextDirection(getTextDirection(text)), [text]);
  return textDirection;
}

export default useTextDirection;
